import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { ENV } from '@app/env';
import { ICoupon } from 'models/coupon.model';
import * as firebase from 'firebase';
import { UtilitiesProvider } from './utilities';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable()
export class PQRData {

    public clientId = ENV.client;

    constructor(
        private afDatabase: AngularFireDatabase,
        private utilities: UtilitiesProvider,
        private http: HttpClient
    ) { }

    public getUserPQR(clientId, userId) {
        return this.afDatabase.list<any>(`/Clients/${clientId}/UserPQR/${userId}/`).valueChanges();
    }

    public getUserPQRById(pqrId, userId) {
        return this.afDatabase.object<any>(`Clients/${this.clientId}/UserPQR/${userId}/${pqrId}`).valueChanges();
    }

    get defaultTemplateNotificationAreaClub() {
        // tslint:disable-next-line:max-line-length
        return "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/Mails%2FtemplateNotificationNewPQR.html?alt=media&token=eb892d64-3fe8-4a5c-ac6b-4fa67f7eda6d";
    }

    public async createPQR(
        pqr,
        userId,
        photos: { data: string | ArrayBuffer, new: boolean, file?: File }[],
        id: string = "",
    ) {
        id = this.afDatabase.createPushId();
        const created_at = firebase.database.ServerValue.TIMESTAMP;
        pqr.id = id;
        pqr.created_at = created_at;
        pqr.userId = userId;
        const imageLoad = photos.map((p, i) => {
            if (p.new) {
                return this.uploadStandImage(p.file, pqr.id, `Image ${i}`);
            } else {
                return Promise.resolve(p.data);
            }
        });
        pqr.photos = await Promise.all(imageLoad);
        const result = this.afDatabase.object(`Clients/${this.clientId}/UserPQR/${userId}/${pqr.id}`).update(pqr).then(() => pqr)
            .catch((error) => {
                this.utilities.consoleError('Whooops, something happen', error);
            })
        return result;
    }

    public async uploadStandImage(file: File, pqrId: string, name: string) {
        const task = await firebase.storage()
            .ref(`/Client/${ENV.client}/PQR/${pqrId}/${name}`)
            .put(file)
            .catch(err => {
                this.utilities.consoleDecorator('Upload error: ', err);
            });
        this.utilities.consoleDecorator('Snapshot: ', task);
        return task.downloadURL;
    }

    public sendEmailNotificationAreaClub(
        emailCategory,
        emailCategoryAdmin,
        subject,
        typePQR,
        message,
        timePQR,
        photos,
        emailUser,
        nameUser,
        template = this.defaultTemplateNotificationAreaClub
    ) {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return this.http.post(`${ENV.backend}/notification/mail`,
            {
                "params": {
                    "subject": subject,
                    "typePQR": typePQR,
                    "message": message,
                    "timePQR": timePQR,
                    "photos": photos,
                    "emailUser": emailUser,
                    "nameUser": nameUser
                },
                "template": template,
                "to": [emailCategory, emailCategoryAdmin],
                "subjet": "Notificación Nuevo PQR",
                "from": "noreply@rebus.com.co"
            }
            , {
                headers: headers
            });
    }


}
// end file



// WEBPACK FOOTER //
// ./src/providers/pqr.ts